import React, { useState, useEffect } from "react";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import { useFormContext } from "./RegistrationFormContext";

const Step5Review = ({ isOpen, onSubmit, isSubmitting, isLoading }) => {
  const token = localStorage.getItem("token");
  const { sharedData } = useFormContext();

  const [contacts, setContacts] = useState([]);
  const [pupils, setPupils] = useState([]);

  const [isLoadingContacts, setIsLoadingContacts] = useState(true); // Set to true initially
  const [isLoadingPupils, setIsLoadingPupils] = useState(true); // Set to true initially

  useEffect(() => {
    if (isOpen && sharedData.userId) {
      fetchPupils();
      fetchContacts();
    }
  }, [isOpen, sharedData.userId]);

  const fetchContacts = async () => {
    setIsLoadingContacts(true);
    try {
      console.log("Fetching contacts with userId:", sharedData.userId); // Debug
      const response = await get(
        `Student/GetStudentFamilyInformationByUserId?userId=${sharedData.userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Fetched contacts:", response); // Debug
      setContacts(response || []);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    } finally {
      setIsLoadingContacts(false);
    }
  };

  const fetchPupils = async () => {
    setIsLoadingPupils(true);
    try {
      console.log("Fetching pupils with userId:", sharedData.userId); // Debug
      const response = await get(
        `Student/GetPupilsInformationByUserId?userId=${sharedData.userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Fetched pupils:", response); // Debug
      setPupils(response || []);
    } catch (error) {
      console.error("Error fetching pupils:", error);
    } finally {
      setIsLoadingPupils(false);
    }
  };

  if (isLoadingContacts || isLoadingPupils) {
    return (
      <div className="form-step">
        <div className="text-center">
          <span className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="form-step">
      {/* <h4 className="fs-8 mb-3">Review Details</h4> */}

      <div className="row g-3">
        <div className="col-md-6">
          <h5>Contacts</h5>
          {isLoadingContacts ? (
            <div className="text-center">
              <span className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </span>
            </div>
          ) : (
            <div className="list-group">
              {contacts.map((contact, index) => (
                <div
                  key={index}
                  className="list-group-item d-flex justify-content-between align-items-center border-primary"
                >
                  <div className="fs-9">
                    {contact.relationShip} - {contact.firstName}{" "}
                    {contact.lastName}
                    {contact.isPrimary && (
                      <span className="badge bg-primary fs-10 ms-2">
                        Primary Contact
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="col-md-6">
          <h5>Pupils</h5>
          {isLoadingPupils ? (
            <div className="text-center">
              <span className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </span>
            </div>
          ) : (
            <div className="list-group">
              {pupils.map((pupil, index) => (
                <div
                  key={index}
                  className="list-group-item d-flex justify-content-between align-items-center border-primary"
                >
                  <div className="fs-9">
                    {pupil.firstName} {pupil.lastName}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="mt-5 text-end">
        <button
          className="btn btn-primary ms-auto"
          type="button"
          onClick={onSubmit}
          disabled={isSubmitting || isLoading}
        >
          {isSubmitting || isLoading ? (
            <span
              className="spinner-border spinner-custom-size me-1"
              aria-hidden="true"
            ></span>
          ) : null}
          <span role="status">Submit & Continue</span>
        </button>
      </div>
    </div>
  );
};

export default Step5Review;
